import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
  MatButtonToggleDefaultOptions,
} from '@angular/material/button-toggle';
import {
  ErrorStateMatcher,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  RippleGlobalOptions,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material/core';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogConfig,
} from '@angular/material/dialog';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import {
  MAT_MENU_DEFAULT_OPTIONS,
  MatMenuDefaultOptions,
} from '@angular/material/menu';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
} from '@angular/material/tooltip';

/**
 * Default Material Design component options for the UPU NSS application.
 */
const MAT_OPTIONS_PROVIDERS = [
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: {
      closeOnNavigation: true,
      hasBackdrop: true,
      role: 'dialog',
      maxWidth: '100%',
    } as MatDialogConfig,
  },
  {
    provide: MAT_MENU_DEFAULT_OPTIONS,
    useValue: {
      xPosition: 'before',
    } as MatMenuDefaultOptions,
  },
  {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: {
      position: 'above',
      showDelay: 500,
    } as MatTooltipDefaultOptions,
  },
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      appearance: 'outline',
      color: 'primary',
      floatLabel: 'auto',
      hideRequiredMarker: false,
    } as MatFormFieldDefaultOptions,
  },
  {
    provide: MAT_RIPPLE_GLOBAL_OPTIONS,
    useValue: {
      disabled: true,
    } as RippleGlobalOptions,
  },
  { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
  {
    provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
    useValue: {
      hideSingleSelectionIndicator: true,
    } as MatButtonToggleDefaultOptions,
  },
];

export const provideMaterialDefaultOptions = (): EnvironmentProviders =>
  makeEnvironmentProviders([...MAT_OPTIONS_PROVIDERS]);
